import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProgramModulesTableComp from './ProgramModulesTableComp';
import ModuleTable from './SideModuleTableComp';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { toArray, arrayToObject, getPretestType, isObjectEmpty } from '../../../Utils';
import { Date } from 'core-js';
import Spinner from '../../common/generic/Spinner';
import Container from 'react-bootstrap/Container';
import { TitleBar, IconEdit} from '../../common/theme';

const StudentTitle = ({pageState, parentState})=>{
    const [title, setTitle] = useState('');

    useEffect(() => {     
        let student = pageState.processedStudentAssignments.find(studRec=>studRec.StudentID === parentState.studentSelectedID);
        if(student && student.Name)
            setTitle(student.Name);
        else
            console.log('Student has no name' + student);
    }); 

    return (
        <Container>
            <Row>  
                <Col xs='8' style={{fontWeight:'bold'}}> <h2> {title} </h2></Col> 
            </Row>            
        </Container>
    );
};

const ProgramTitle = ({pageState, parentState})=>{
    const [title, setTitle] = useState('');

    useEffect(() => {   
        let progName = '';
        if (parentState.programNamesSelected.length===1)
            progName = parentState.programNamesSelected[0];
        setTitle(progName);
    }); 

    return (
        <Container>
            <Row>  
                <Col xs='12' style={{fontWeight:'bold',textAlign:'right'}}> <h2> {title} </h2></Col> 
            </Row>            
        </Container>
    );
};

//    setCheckboxState({}); 
const ContainerComp = ({pageState}) =>{

    const [programsSelected, setProgramsSelected] = useState([]);
    const [programNamesSelected, setProgramNamesSelected] = useState([]);
    const [refreshCompState, setRefreshCompState] = useState(true);
    
    const [isSaving, setIsSaving] = useState(false);
    const [requestState, setRequestState] = useState({});
  
    const componentData = {
        programsSelected, setProgramsSelected,
        programNamesSelected, setProgramNamesSelected,
        refreshCompState, setRefreshCompState,
        studentSelectedID: pageState.showModulesComp,
        isSaving, setIsSaving, requestState: requestState, setRequestState: setRequestState
    };

    // save changes
    useEffect(()=>{
        if(isObjectEmpty(requestState)) return;

        let studID = requestState.studID;
        let allPrograms = arrayToObject(pageState.rawPrograms.programs,'id');
        let schoolID = pageState.database['getCustomer'].data.ID;
        // let classID = pageState.classID;
        
        const {ClassID:classID, attachID} = toArray(pageState.database['getStudentsForClass'].data).filter(s=>s.StudentID===studID)[0];        
        let attachedID = attachID?attachID:'';

        let saveChanges = [];
        let willOverride = false;

        // remove all assignements/pretests and posttests
        if(requestState.assign==='all'){
            requestState.programs.forEach(progID=>{
                let progName = allPrograms[progID].title;
                saveChanges.push({debug:'RemoveAll', func:'deleteAssignment', params: `${studID}~${progName}`});
            });
        }

        if(requestState.assign==='assignments'){
            requestState.programs.forEach(progID=>{

            let progName = allPrograms[progID].title;
            let allModules = allPrograms[progID].modules.reduce((acc,e)=>{acc += ';'+e[0]; return acc;},'').substr(1);           
            let modules = (requestState.assignedModules)?requestState.assignedModules:allModules;
 
            let pretestType = getPretestType(progID);
            if(`${studID}+${progName}` in pageState.database['getAllClassAssignments'].data ||
               `${studID}+${progID}`   in pageState.database['getAllClassAssignments'].data)
                    willOverride = true;

                if(requestState.type==='add'){
                    saveChanges.push({debug:'Assignment', func:'saveTeacherAssignment', params: `${studID}~${progName}~N${pretestType}${modules}~${classID}~${attachedID}~${schoolID}`});
                }else{
                    saveChanges.push({debug:'Assignment', func:'deleteAssignment', params: `${studID}~${progName}`});
                }
            });
        }

        if(requestState.assign==='test'){
            requestState.programs.forEach(progRec=>{
                let {programID:progID, type, test} = progRec;
                progID = progID.toUpperCase();
                let progName = allPrograms[progID].title;
                let modules = allPrograms[progID].modules.reduce((acc,e)=>{acc += ';'+e[0]; return acc;},'').substr(1);
                let pretestType = getPretestType(progID);

                if(`${studID}+${progName}` in pageState.database['getAllClassAssignments'].data ||
                   `${studID}+${progID}`   in pageState.database['getAllClassAssignments'].data)
                    willOverride = true;
    
                if(test==='posttest'){
                    if(type==='add'){
                        const date = new Date();
                        let currentTime = date.getTime();
                        saveChanges.push({debug:'Posttest', func:'saveTeacherAssignment', params: `${studID}~${progName}~Y_${currentTime}${pretestType}${modules}~${classID}~${attachedID}~${schoolID}`});
                    }else{
                        saveChanges.push({debug:'Posttest', func:'deleteAssignment', params: `${studID}~${progName}`});
                    }
                }

                if(test==='pretest'){
                    if(type==='add'){
                        saveChanges.push({debug:'Pretest', func:'saveTeacherAssignment', params: `${studID}~${progName}~Y${pretestType}${modules}~${classID}~${attachedID}~${schoolID}`});
                        saveChanges.push({debug:'Pretest', func:'deletePretest', params: `${studID}~${progName}`}); 
                    }else{
                        saveChanges.push({debug:'Pretest', func:'deleteAssignment', params: `${studID}~${progName}`});
                    }
                }
            });
        }           
    
        if(willOverride && !window.confirm('One or more students have a Pre-Test or a Post Test or an Assignment that will be replaced! Press ok to overwrite their assignments.'))
            return;

        // create a link list of save changes querys for saving to the database
        if(saveChanges.length > 0){
            setIsSaving(true);
            let counter = 1;
            saveChanges = saveChanges.map((query,i)=>{
                let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
                if(prevQuery !== 'undefinded'){
                    counter++;
                    query.nextRequest = prevQuery;
                }
                return query;
            });
            let saveChainedChanges = saveChanges[saveChanges.length-1];
            saveChainedChanges.numQueries = counter;
            // pass the link list of saved changes into the database
            pageState.request(saveChainedChanges); 
        }

    },[requestState]);

    // Check when saving has completed by wating for database.queryCount to become 0
    // UPDATES - database.queryCount changes -&&- only when saving
    useEffect(()=>{
        if(isSaving){
            if(pageState.database.queryCount == 0){
                setIsSaving(false);
                pageState.deleteThis('getStudentsForClass');
                pageState.deleteThis('getAllClassAssignments');
                componentData.setProgramsSelected([]);
                // pageState.setShowModulesComp('');                  
            }
        }
    },[pageState.database.queryCount]);

    // refesh the children when a new program is selected
    useEffect(() => { setRefreshCompState(true);},[pageState.showModulesComp]);

    return <>{(pageState.showModulesComp!=='') && <div><StudentModuleContainer pageState={pageState} componentData={componentData} /></div>}</>;

};

const StudentModuleContainer = ({pageState, componentData}) => {
    const hideModules = () => {
        componentData.setProgramsSelected([]);
        pageState.setShowModulesComp('');  
    };
    const mouseEnter=()=>pageState.setHasMouseInsideModulesPanel(true);
    const mouseLeave=()=>pageState.setHasMouseInsideModulesPanel(false);

    if((!componentData.isSaving) && pageState.database['queryCount']!==0)
        return(<><Spinner/></>);    
    return(
     <>
     <Row>        
         <Col xs={1} ><Button variant={'danger'} onClick={()=>hideModules()}>Back</Button></Col> 
         <Col xs={11}><Alert variant='primary'> <strong>Note:</strong> To select multiple students, please select a program from an <strong>Assignment Group</strong> on the previous page</Alert> </Col>
    </Row>
        <br/>
        <Row>        
            <Col xs={6}><StudentTitle pageState={pageState} parentState={componentData}/> </Col>
            <Col xs={6}><ProgramTitle pageState={pageState} parentState={componentData}/> </Col>
        </Row>

        <Row>
            <Col xs={8}>
                <Col xs={12}>
                    <IconEdit style={{fontWeight:'bold', color:'red'}}/> Pretest Assigned Modules  &nbsp;&nbsp; <IconEdit style={{fontWeight:'bold', color:'green'}}/> Teacher Assigned Modules 
                </Col>
            </Col>
        </Row>

        <Row>

        <Col xs={8}>{(componentData.isSaving)?
                <Alert variant={'danger'}><Spinner/> <center>Saving...({pageState.database.queryCount})</center></Alert>:
                <Col xs={12}><ProgramModulesTableComp pageState={pageState} parentState={componentData}/></Col>}
            </Col> 
            {(componentData.programsSelected.length ==0)
                ?<Col xs={4} style={{ border: '1px solid #cfcfcf'}}>
                    <TitleBar>
                        <Col>Assigning Program Modules</Col>
                    </TitleBar>
                    <br/>
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    <Alert variant={'success'}> Selecting multiple programs will remove the option to assign modules & selected programs will be assigned in their entirety</Alert>
                    <Alert variant={'danger'}>Pre and Posttests can only be assigned for entire programs and not specific program modules.</Alert>
                </Col>
                :<Col xs={4} onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}><ModuleTable pageState={pageState} parentState={componentData}/></Col>
            }
        </Row>

        <Row></Row>
    </>);
};

export default ContainerComp;